import { Money } from '@dreryk/money-common-api';

import {
   createInterpolatedTranslationKey,
   getCustomFormattingContext,
   InterpolatedTranslationKey,
   priceFormatter,
} from '@dreryk/react-common';

const formatAmount = (amount: number): string | null => {
   return priceFormatter(
      amount,
      getCustomFormattingContext({
         options: {
            currency: 'PLN',
            stripDecimalZeroes: true,
         },
      })
   );
};

export const getUnderpaymentAmount = (paidAmount: Money, requiredAmount: Money): number => {
   return requiredAmount.asNumber() - paidAmount.asNumber();
};

export const getOverpaymentAmount = (paidAmount: Money, requiredAmount: Money): number => {
   return Math.abs(requiredAmount.asNumber() - paidAmount.asNumber());
};

export const getUnderpaymentLabel = (
   translationKey: string,
   paidAmount: Money,
   requiredAmount: Money
): InterpolatedTranslationKey => {
   return createInterpolatedTranslationKey(translationKey, {
      amount: formatAmount(getUnderpaymentAmount(paidAmount, requiredAmount)),
   });
};

export const getOverpaymentLabel = (
   translationKey: string,
   paidAmount: Money,
   requiredAmount: Money
): InterpolatedTranslationKey => {
   return createInterpolatedTranslationKey(translationKey, {
      amount: formatAmount(getOverpaymentAmount(paidAmount, requiredAmount)),
   });
};
